
<div class="right-side p-5">
  <div class="section">   
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
      <!--<div class="card-title">
    <h1>Profile</h1>
  </div>-->
      <div class="card mb-3">
        <div class="card-header"> <h2>Event Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Event ID</mat-label>
                <input matInput formControlName="eventId">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Date of Event</mat-label>
                <input matInput formControlName="eventDate">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Event Time</mat-label>
                <input matInput formControlName="time">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>UDYAM Number</mat-label>
                <input matInput formControlName="udyamRegistrationNumber">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Implementation Agency</mat-label>
                <input matInput formControlName="nameOfOrganisation">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Intervention</mat-label>
                <input matInput formControlName="interventionName">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Component</mat-label>
                <input matInput formControlName="interestName">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"> <h2>Entrepreneur Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Name of Entrepreneur</mat-label>
                <input matInput formControlName="nameOfEnterprise">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Type of Organization</mat-label>
                <input matInput formControlName="typeOfOrganization">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Owner's Mobile Number</mat-label>
                <input matInput formControlName="ownersMobileNumber">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Owner’s Gender</mat-label>
                <input matInput formControlName="gender">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Sector</mat-label>
                <input matInput formControlName="sector">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Social Category</mat-label>
                <input matInput formControlName="socialCategory">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Owner’s Address</mat-label>
                <input matInput formControlName="ownersaddress">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Official Address of Enterprise</mat-label>
                <input matInput formControlName="officialAddressOfEnterprise">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>State</mat-label>
                <input matInput formControlName="stateName">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>District</mat-label>
                <input matInput formControlName="districtName">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Block</mat-label>
                <input matInput formControlName="block">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>City</mat-label>
                <input matInput formControlName="city">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Pin</mat-label>
                <input matInput formControlName="pin">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Entrepreneur Details Section -->
      <!-- Training Details Section -->
      <!--<div class="section">
    <h2>Training Details</h2>
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>Name of Participant</mat-label>
          <input matInput formControlName="participantName">
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>Mobile Number</mat-label>
          <input matInput formControlName="mobileNumber">
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="emailId">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
                <div class="col">
      <mat-form-field appearance="outline">
        <mat-label>District</mat-label>
        <input matInput formControlName="tdistrict">
      </mat-form-field>
    </div>
                <div class="col">
      <mat-form-field appearance="outline">
        <mat-label>Town</mat-label>
        <input matInput formControlName="town">
      </mat-form-field>
    </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>Designation</mat-label>
          <input matInput formControlName="designation">
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>Title of Training</mat-label>
          <input matInput formControlName="eventName">
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>Event Trainer Name</mat-label>
          <input matInput formControlName="trainerName">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
    </div>
  </div>-->

      <!--This is for PArticipant Details-->      
      <div class="card mb-3">
        <div class="card-header"> <h2>Participant Details</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Participant Name</mat-label>
                <input matInput formControlName="participantName">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Mobile Number</mat-label>
                <input matInput formControlName="mobileNumber">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Designation</mat-label>
                <input matInput formControlName="designation">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input matInput formControlName="emailId">
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>EnrollmentID</mat-label>
                <input matInput formControlName="enrollmentId">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div *ngFor="let questionType of getSectionKeys()">
        <h2>{{ questionType }}</h2>
        <div class="section">

          <div *ngFor="let question of sections[questionType]">

            <div class="row">
              <mat-label>{{ question.questionText }}</mat-label>
              <div class="col">
                <!-- Specific condition for toolkit question -->
                <div *ngIf="question.questionText === 'Was any toolkit/ booklet/e-book shared after the training?'" class="options-container">
                  <mat-radio-group [formControlName]="question.questionId">
                    <mat-radio-button *ngFor="let option of ['Yes', 'No']" [value]="option">
                      {{ option }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <!-- General options for other questions -->
                <div *ngIf="question.questionText !== 'Was any toolkit/ booklet/e-book shared after the training?'" class="options-container">
                  <mat-radio-group [formControlName]="question.questionId">
                    <mat-radio-button *ngFor="let option of options" [value]="option">
                      {{ option }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>

      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-checkbox formControlName="declarationchk">
            Declaration & T/c: I, hereby confirm that I will share the benefits availed post vendor development program / workshop / training during the feedback survey conducted by MSSIDC quarterly, semi-annually, and annually.
          </mat-checkbox>
        </div>
      </div>
      <br />
      <!-- Submit Button -->
      <!--<button mat-raised-button color="primary" type="submit">Submit</button>-->
      <button type="submit" class="btn btn-success rounded-pill shadow">Submit</button>

    </form>
    
  </div>
</div>
